import { put } from "redux-saga/effects";
// import { UserAgent } from 'ipapps-corejs';
import { SUBSCRIPTION_ACTION_TYPES } from "../actionTypes";

// const up = new UserAgent();

export function* identifyUser() {
  try {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_USER,
      payload: false
      // payload: up.type === 1,
    });
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_PROFILE,
      payload: {}
      // payload: up.id,
    });
  } catch (error) {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.ERROR,
      error
    });
  }
}

export function* setUserProfile({ payload }) {
  try {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_PROFILE,
      payload
    });
  } catch (error) {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.ERROR,
      error
    });
  }
}

export function* setUserProfiles(payload) {
  try {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.SET_PROFILES,
      payload
    });
  } catch (error) {
    yield put({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.ERROR,
      error
    });
  }
}
